module.exports = __webpack_public_path__ + "img/upload-arrow.db148608.svg";